
const onClick = e => {
    e.preventDefault();
    
    const inputSubmit = e.target.closest('form').querySelector('input[type=submit]');
    //console.log(form);
    inputSubmit.click();

    // form.validate();
    // form.submit();
   
  };
  
  export const cleanForms = () => {
    const submitforms = document.querySelectorAll(".submit-form");
    submitforms.forEach(o => {
      o.removeEventListener("click", onClick);
    });
  };
  
  export const initForms = () => {
    const submitforms = document.querySelectorAll(".submit-form");
   
    submitforms.forEach(o => {
      o.addEventListener("click", onClick);
    });
  };
  